import CommonES from "./translated/es/common/common.json";
import BurnModalES from "./translated/es/components/burnModal.json";
import FilterDropdownES from "./translated/es/components/filterDropdown.json";
import LoadingErrorMessageES from "./translated/es/components/loadingErrorMessage.json";
import LoadingTransactionsModalES from "./translated/es/components/loadingTransactionsModal.json";
import TableComponentES from "./translated/es/components/table.json";
import TiersModalES from "./translated/es/components/tiersModal.json";
import UnboughtTierES from "./translated/es/components/unboughtTier.json";
import ValidatorStakingModalES from "./translated/es/components/validatorStakingModal.json";
import WalletModalES from "./translated/es/components/walletModal.json";
import AccountToolsES from "./translated/es/pages/accountTools.json";
import AllPagesES from "./translated/es/pages/allPages.json";
import DashboardES from "./translated/es/pages/dashboard.json";
import DefiOnSolanaES from "./translated/es/pages/defiOnSolana.json";
import NFTGalleryES from "./translated/es/pages/nftGallery.json";
import ReferralsES from "./translated/es/pages/referrals.json";
import ReferrerInviteES from "./translated/es/pages/referrerInvite.json";
import StepStakingES from "./translated/es/pages/stepStaking.json";
import SwapLPES from "./translated/es/pages/swapLP.json";
import TransactionHistoryES from "./translated/es/pages/transactionHistory.json";

export const spanishSource = {
  common: CommonES,
  components: {
    burnModal: BurnModalES,
    table: TableComponentES,
    filterDropdown: FilterDropdownES,
    tiersModal: TiersModalES,
    unboughtTier: UnboughtTierES,
    walletModal: WalletModalES,
    loadingErrorMessage: LoadingErrorMessageES,
    loadingTransactionsModal: LoadingTransactionsModalES,
    validatorStakingModal: ValidatorStakingModalES,
  },
  pages: {
    accountTools: AccountToolsES,
    allPages: AllPagesES,
    dashboard: DashboardES,
    defiOnSolana: DefiOnSolanaES,
    nftGallery: NFTGalleryES,
    stepStaking: StepStakingES,
    swapLP: SwapLPES,
    referrals: ReferralsES,
    referrerInvite: ReferrerInviteES,
    transactionHistory: TransactionHistoryES,
  },
};
